import { useEffect } from "react";

import { SurveyViewFormValues } from "@/views/survey-views/types";
import { useGetSurveyViewPreviewMutation } from "@/redux/service";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import { SurveyViewColorScheme } from "@/redux/survey-views/types";

const Preview = ({
  surveyViewData,
}: {
  surveyViewData: SurveyViewFormValues;
}) => {
  const [getPreview, previewResponse] = useGetSurveyViewPreviewMutation();

  useEffect(() => {
    if (surveyViewData) {
      const data = {
        version: 2,
        ...surveyViewData,
        config: {
          ...surveyViewData.config,
          colorScheme: surveyViewData.config.grayScale
            ? SurveyViewColorScheme.GRAY_SCALE
            : SurveyViewColorScheme.DEFAULT,
        },
        answers: surveyViewData.answers.map((answer) => ({
          ...answer,
          blocks: answer.blocks.map((block) => ({
            id: block.id,
          })),
        })),
      };
      getPreview(data);
    }
  }, [surveyViewData]);

  return (
    <div>
      {previewResponse.isLoading && (
        <div className="preview-loading-container">
          <BaseSpinner />
        </div>
      )}
      {previewResponse.isSuccess && (
        <iframe
          srcDoc={previewResponse.data.htmlData}
          height="100%"
          width="800px"
          title="Survey Data"
        />
      )}
    </div>
  );
};

export default Preview;
